
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recettes",
      function () {
        return require("private-next-pages/recettes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recettes"])
      });
    }
  